import { discoverConfig, recruitsConfig } from './module/shared'
import membersRoutes from './module/members'
import campusRoutes from './module/campus'

export default [
    ...discoverConfig.routes, 
    ...recruitsConfig.routes,
    ...membersRoutes, 
    ...campusRoutes, 
    {

        path: '/campuscharitycampaign',
        redirect: { name: 'campus-resources-video' }
    }
]
